module.exports = __webpack_public_path__ + "img/IC_Ausencia_Justificada.1ce36052.svg";